import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MeasureService } from 'src/app/services/measure.service';
import { NotificationManager } from '../notification-manager';
import { PlanningConfiguration } from 'src/app/domain/planning-configuration';
import { User } from 'src/app/domain/user';
import { StringConverter } from '../string-converter';
import { ESubContractingLab } from 'src/app/domain/enums/sub-contracting-lab';
import { MasterCompetenceService } from 'src/app/services/mastercompetence.service';
import { Competence } from 'src/app/domain/competence';
import { AddressService } from 'src/app/services/address.service';
import { SamplerAddress } from 'src/app/model/sampler-address';
import { MatSelectChange } from '@angular/material/select';

enum EExoticType {
    EAU,
    MASSIF,
    LINGETTE
}

@Component({
    selector: 'user-configuration-box',
    templateUrl: 'user-configuration-box.html',
    styleUrls: ['./user-configuration-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserConfigurationDialog implements OnInit {
    LabList: string[] = Object.values(ESubContractingLab).filter(x => !isNaN(Number(x))).map(x => StringConverter.getLabCodeName(x as ESubContractingLab));
    MasterCompetenceList: Competence[] = []
    Model: User = new User()
    public DayStartTime: any;
    public MinPauseTime: any;
    AddressList: SamplerAddress[] = [];

    constructor(
        private snackbar: MatSnackBar,
        private addressService: AddressService,
        private masterCompetenceService: MasterCompetenceService,
        public dialogRef: MatDialogRef<UserConfigurationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: User) {
        if (data) {
            this.Model = data;
            this.DayStartTime = this.Model.PlanningConfiguration.HeureDebutJournee.substring(0, this.Model.PlanningConfiguration.HeureDebutJournee.length - 3);
            this.MinPauseTime = this.Model.PlanningConfiguration.HeurePauseMinimale.substring(0, this.Model.PlanningConfiguration.HeureDebutJournee.length - 3);
            console.log(this.DayStartTime)
            if (!data.PlanningConfiguration)
                data.PlanningConfiguration = new PlanningConfiguration()

            this.getSamplerAddressList()
        }
    }

    ngOnInit() {
        this.masterCompetenceService.getMasterCompetenceList().subscribe(x => {
            this.MasterCompetenceList = x;
        })
    }

    getSamplerAddressList() {
        this.addressService.getAdresses(this.Model.Puid).subscribe(x => {
            this.AddressList = x;
        })
    }

    departChanged(event: MatSelectChange) {
        if (!event.value)
            return;
        this.Model.PlanningConfiguration.AdresseDepart = event.value.Address
        this.Model.PlanningConfiguration.LatitudeDepart = event.value.Latitude
        this.Model.PlanningConfiguration.LongitudeDepart = event.value.Longitude
    }

    arriveeChanged(event: MatSelectChange) {
        if (!event.value)
            return;
        this.Model.PlanningConfiguration.AdresseArrivee = event.value.Address
        this.Model.PlanningConfiguration.LatitudeArrivee = event.value.Latitude
        this.Model.PlanningConfiguration.LongitudeArrivee = event.value.Longitude
    }

    DayStartTimeSet(event: any) {
        // const time = event.split(':');
        this.Model.PlanningConfiguration.HeureDebutJournee = `${event}:00`
        // this.DayStartTime = new Date(this.DayStartTime);
        // this.DayStartTime.setHours(Number(time[0]), Number(time[1]));
    }

    MinPauseTimeSet(event: any) {
        // const time = event.split(':');
        this.Model.PlanningConfiguration.HeurePauseMinimale = `${event}:00`
        // this.MinPauseTime = new Date(this.MinPauseTime);
        // this.MinPauseTime.setHours(Number(time[0]), Number(time[1]));
    }

    public compareWith(m1: Competence, m2: Competence) {
        return m1 && m2 ? m1.Name === m2.Name : m1 === m2;
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        this.dialogRef.close(this.Model)
    }
}
